import React, { useContext, useEffect, useRef, useState } from 'react'
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Slider from "react-slick";
import { getImages } from '../Common/const'
import MyVehicleForm from '../Common/MyVehicleForm';
import ModalLayout from '../Common/ModalLayout';
import SellVehicleModal from '../Components/SellMyVehicle/SellVehicleModal';
import SeoMeta from '../Common/SeoMeta';
import { VehicleContext } from '../Context/VehicleContext';

const reviewsList = [
    {
        name: "Darren Magot",
        date: '2 months ago',
        content:
            "I had a great experience with these guys. They have such a wide variety of unique vehicles. Definitely will be going back whenever I’m in the area to see what’s new.",
    },
    {
        name: "R PHOTOSTUDIOS",
        date: 'a month ago',
        content:
            "Jackson was very welcoming when we visited the showroom. Knowledgeable and patient with my son who was so excited to see their cars.",
    },
    {
        name: "cat lover",
        date: '2 months ago',
        content:
            "Tim had great communication. I didn’t see the car in person, so I had to trust…and I ended up very pleased. As described. Thank you",
    },

    {
        name: "Alek Arciniega",
        date: 'a month ago',
        content:
            "Awesome place to go look at exotic cars. The guys working there were very helpful and informative. Definitely recommend coming here and checking this place out.",
    },
    {
        name: "Muntasir Hoque",
        date: '6 days ago',
        content:
            "Excellent experience with purchase and delivery of a vehicle from EEC! Jaxon was my point of contact, and he was incredibly knowledgeable and friendly the entire process. They delivered the vehicle to a location of my choosing, and made the entire experience a pleasure. I cannot recommend Jaxon and EEC enough. This is the best place in California to purchase exotic automobiles!",
    },

    {
        name: "Ishnmuich Perez",
        date: 'a month ago',
        content:
            "Very friendly professional staff. Not only were they very friendly and courteous with my son, but they gave us good information on their weekly car shows held at the parking lot.",
    },
    {
        name: "Summer Shaffer",
        date: '2 months ago',
        content:
            "Whole staff was super friendly and very knowledgeable. Was the easiest car purchase I’ve ever made. Will be my first call when I’m ready for something new!",
    },
];

const initialValues = {
    year: "",
    make: "",
    model: "",
    mileage: "",
    email: "",
    skip_adf: true
};

const validationSchema = Yup.object({
    year: Yup.string().required("Year is required"),
    make: Yup.string().required("Make is required"),
    model: Yup.string().required("Model is required"),
    mileage: Yup.string().required("Mileage is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
});
const SellMyVehicleTampa = () => {

    const { getCMSData } = useContext(VehicleContext);

    const [cmsData, setCMSData] = useState({});

    const getPageData = async () => {
        setCMSData(await getCMSData('sell'));
    }
    useEffect(() => {
        getPageData();
    }, []);
    const getCMSValue = (field) => {
        return field in cmsData ? cmsData[field] : "";
    }
    const sliderRef = useRef(null);
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 2,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: true,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };
    const [openSellCarModal, setOpenSellCarModal] = useState(false);
    const [sellCarData, setSellCarData] = useState("");
    const [checkForm, setCheckForm] = useState(0);

    const handleSellCarModal = (sellCarInfo) => {
        setOpenSellCarModal(true);
        setSellCarData(sellCarInfo);
        document.body.classList.add('body-overflow');
    }
    const closeSellCarModal = () => {
        console.log('closed');
        setOpenSellCarModal(false);
        //setSellCarData("");
        document.body.classList.remove('body-overflow');
        setCheckForm((prev) => prev + 1);
    }
    return (
        <>
            {/* <SeoMeta
                title="Sell My Exotic and Super Car | We Buy Exotics"
                description="Thinking about selling your Ferrari, Lamborghini, Bentley, Maserati, Porsche, or McLaren? Get your free cash offer today - online. Easy, Simple, Trustworthy."
                keywords=""
                ogTitle="Sell My Exotic and Super Car | We Buy Exotics"
                ogDescription="Thinking about selling your Ferrari, Lamborghini, Bentley, Maserati, Porsche, or McLaren? Get your free cash offer today - online. Easy, Simple, Trustworthy."
            /> */}
            <section className="common-banner-wrap repair-banner consign-banner">
                <img src={getImages('sell_car_hero.webp')} alt='automotive' />
                <div className="container">
                    <div className='common-banner-pos pt-5 text-center'>
                        <h1 className='banner-lg-title text-uppercase wow reveal fadeInUp'>Sell Your Exotic Car</h1>
                        <div className='md-title font-2em fw-500 text-center mt-3 mb-4 wow reveal fadeInUp avenir-next'>We Are Immediate Cash Buyers</div>
                    </div>
                </div>
            </section>
            <section className='hassle-process-wrap' id="vehicle-offer-form">
                <div className='container'>
                    <div className='hassle-process-box d-md-flex wow reveal fadeIn'>
                        <div className='hpb-right w-50 order-2'>
                            <div className='xxl-title font-2-5em text-white fw-300 text-uppercase mb-4 text-start wow reveal fadeInUp'>Enter Vehicle Info</div>
                            <div className='wow reveal fadeInUp'>
                                <Formik
                                    initialValues={initialValues}
                                    validationSchema={validationSchema}
                                    onSubmit={async (values, { resetForm }) => {

                                        // const token = await recaptchaRef.current.executeAsync();
                                        // recaptchaRef.current.reset(); // Reset after use

                                        // values = { ...values, token: token };
                                        // console.log(values);
                                        // const data = await submitContactForm(values);

                                        // if (data.success) {
                                        //     resetForm();
                                        //     alert("Thank you for your submission. We'll be in touch soon!");
                                        // } else
                                        //     alert("There was a problem with your submission");

                                        // console.log(values);
                                        // handleSellCarModal(values);
                                        // resetForm();
                                    }}
                                >
                                    {({ isValid, values, validateForm, setFieldTouched, resetForm }) => (
                                        <Form className="custom-form sell-vehicle-form">
                                            <Field type="hidden" name="skip_adf" value={true} />
                                            {/* <ReCAPTCHA
                                                ref={recaptchaRef}
                                                sitekey="6LckXRIsAAAAAAiOe2UBkXy7Uy-ROdiueqrr4Lzk" // Replace with your actual site key
                                                size="invisible"
                                            /> */}
                                            <div className="form-group">
                                                <Field
                                                    type="text"
                                                    name="year"
                                                    placeholder="Year"
                                                    className="form-control"
                                                />
                                                <ErrorMessage name="year" component="div" className="text-danger" />
                                            </div>

                                            <div className="form-group">
                                                <Field
                                                    type="text"
                                                    name="make"
                                                    placeholder="Make"
                                                    className="form-control"
                                                />
                                                <ErrorMessage name="make" component="div" className="text-danger" />
                                            </div>

                                            <div className="form-group">
                                                <Field
                                                    type="text"
                                                    name="model"
                                                    placeholder="Model"
                                                    className="form-control"
                                                />
                                                <ErrorMessage name="model" component="div" className="text-danger" />
                                            </div>

                                            <div className="form-group">
                                                <Field
                                                    type="text"
                                                    name="mileage"
                                                    placeholder="Mileage"
                                                    className="form-control"
                                                />
                                                <ErrorMessage name="mileage" component="div" className="text-danger" />
                                            </div>

                                            <div className="form-group">
                                                <Field
                                                    type="email"
                                                    name="email"
                                                    placeholder="Email"
                                                    className="form-control"
                                                />
                                                <ErrorMessage name="email" component="div" className="text-danger" />
                                            </div>

                                            <button
                                                type="button"
                                                className="orange-white-btn w-100 fw-700 text-uppercase"
                                                onClick={() => {
                                                    Object.keys(values).forEach(fieldName => {
                                                        setFieldTouched(fieldName, true, true); // true for touched status, true to run validation
                                                    });

                                                    validateForm().then((errors) => {
                                                        if (isValid && Object.keys(errors).length == 0) {
                                                            console.log(values);
                                                            handleSellCarModal(values);
                                                            resetForm();
                                                        } else {
                                                            console.log("not valid");
                                                        }
                                                    });


                                                }}
                                            >
                                                Next
                                            </button>
                                        </Form>
                                    )}
                                </Formik>
                            </div>
                        </div>
                        <div className='hpb-left w-50'>
                            <div className='hpb-xs-title text-uppercase text-orange mb-2 wow reveal fadeInUp'>Call or text</div>
                            <div className='text-center wow reveal fadeInUp'>
                                <a href='tel:9495058845' className='lg-title call-text-title text-white font-40 fw-700'>(949) 505-8845</a>
                            </div>
                            <div className='md-title font-1-9em text-center text-orange fw-300 text-uppercase mt-md-5 mt-4 mb-md-4 mb-3 wow reveal fadeInUp'>How Our Process Works</div>
                            <div className='hpb-process-list'>
                                <div className='d-flex align-items-center wow reveal fadeInUp'>
                                    <div className='hpb-circle me-3'>1</div>
                                    <div className='xs-title avenir-next fw-500'>Send in your vehicle information</div>
                                </div>
                                <div className='d-flex align-items-center wow reveal fadeInUp'>
                                    <div className='hpb-circle me-3'>2</div>
                                    <div className='xs-title avenir-next fw-500'>Quickly receive an offer</div>
                                </div>
                                <div className='d-flex align-items-center wow reveal fadeInUp'>
                                    <div className='hpb-circle me-3'>3</div>
                                    <div className='xs-title avenir-next fw-500'>Finalize with our friendly agents</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='sell-car-map-wrap'>
                <div className='scm-block'>
                    <div className='container'>
                        <div className='scm-box'>
                            <div className='md-title font-2em fw-700 text-center text-uppercase mb-md-3 mb-3 wow reveal fadeInUp d-none d-md-block'>
                                Come to the store <span className='text-orange'>OR</span> sell from the comfort of your home
                            </div>
                            <div className='scm-mobile-titles d-md-none wow reveal fadeInUp'>
                                <div className='scm-mobile-subtitle'>Come to the store</div>
                                <div className='scm-mobile-divider'>
                                    <span>OR</span>
                                </div>
                                <div className='scm-mobile-subtitle'>Sell from the comfort of your home</div>
                            </div>
                            <div className='md-title font-1-9em fw-400 text-center text-uppercase text-orange wow reveal fadeInUp'>We handle everything.</div>
                        </div>
                        <div className='text-center mt-5'>
                            <a href='#vehicle-offer-form' className='orange-white-btn fw-700 text-uppercase w-330 lg-btn d-inline-block text-center'>Get My Cash Offer</a>
                        </div>
                    </div>
                </div>
                <iframe src="https://snazzymaps.com/embed/739247" width="100%" height="420px" style={{ border: 'none', pointerEvents: 'auto' }}></iframe>
            </section>
            <section className='sell-recent-wrap pt-100'>
                <div className='container'>
                    {/* {getCMSValue('sellYourCarShowGoogleReviews') && ( */}
                    <div className='sell-recent-block'>
                        <div className='d-md-flex align-items-center justify-content-between usw-flex mb-4 px-4'>
                            <div className='text-start'>
                                <h3 className='xxl-title font-2-5em fw-300 mb-2 text-uppercase reveal wow fadeInUp'>Unmatched Service</h3>
                                <div className='xs-title font-1-2em fw-700 text-uppercase reveal wow fadeInUp'><span className='text-orange'>153</span> Google reviews</div>
                            </div>
                            <div className='d-flex align-items-center g-review-flex justify-content-between'>
                                <div className='me-4'>
                                    <div className='xxl-title font-3em fw-700 mb-1 text-uppercase reveal wow fadeInUp'>5.0</div>
                                    <div className="d-flex align-items-center">
                                        {[...Array(5)].map((_, i) => (
                                            <img key={i} className="me-1 mrs-icon" src={getImages("star.svg")} alt="star" />
                                        ))}
                                    </div>
                                </div>
                                <div className='review-google-icon'>
                                    <img src={getImages('icon-testimonial-user1.png')} />
                                </div>
                            </div>
                        </div>
                        <div className='reveal wow fadeIn'>
                            <Slider ref={sliderRef} {...settings} className='review-slider'>
                                {reviewsList.map((review, index) => (
                                    <div className="review-item" key={index}>
                                        <div className="review-box">
                                            <div className="d-flex justify-content-between mt-1">
                                                <div>
                                                    <div className="reviewer-name">{review.name}</div>
                                                    <div className="d-flex align-items-center">
                                                        {[...Array(5)].map((_, i) => (
                                                            <img key={i} className="me-1 rs-icon" src={getImages("star.svg")} alt="star" />
                                                        ))}
                                                    </div>
                                                </div>
                                                <div>
                                                    <div className="quote-icon mb-2">
                                                        <img src={getImages("quote-shape.png")} alt="quote" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="review-mnh">
                                                <p className="clamp-4">
                                                    {review.content}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                ))}

                            </Slider>
                        </div>
                    </div>
                    {/* )} */}
                    <div className='tranding-selling-block'>
                        <div className='md-title font-2-5em fw-600 text-center text-uppercase mb-4 wow reveal fadeInUp'>Get an Instant <span className='text-orange'>Cash Offer</span> for your Vehicle</div>
                        <div className='common-text text-center px-5 mxw-1000 wow reveal fadeInUp'>
                            <p>Providing the most accurate description will help you get the most money possible. Sending us some pictures, a copy of the MSRP, and service history is always very helpful. Remember, we want your car!</p>
                        </div>
                        <div className='mt-4 text-center wow reveal fadeInUp'>
                            <a href='#vehicle-offer-form' className='orange-white-btn fw-700 text-uppercase w-330 lg-btn d-inline-block text-center'>Get My Cash Offer</a>
                        </div>
                    </div>
                </div>
            </section>

            <ModalLayout open={openSellCarModal} close={closeSellCarModal} darkThemeCls='true' cls="sell-vehicle-modal" modalWidth={1080}>
                <SellVehicleModal
                    close={closeSellCarModal}
                    sellCarData={sellCarData}
                    checkForm={checkForm}
                />
            </ModalLayout>
        </>
    )
}

export default SellMyVehicleTampa